import styled, { css } from 'styled-components'
import { StyledGhostButton } from '../styles'

export const ShareIconWrapper = styled.div<{ isPrimary?: boolean }>(
    ({ theme, isPrimary }) => css`
        display: flex;
        align-items: center;

        svg {
            transition:
                stroke 0.2s ease,
                fill 0.2s ease;
        }

        ${!isPrimary &&
        css`
            ${StyledGhostButton}:hover & svg path {
                stroke: ${theme.colors.white};
                fill: ${theme.colors.black};
            }
        `}
    `,
)
